import { bootstrapApplication } from '@angular/platform-browser';
import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from '@brighthub/environment';
import { enableProdMode } from '@angular/core';
import * as Sentry from '@sentry/angular';
import {
  SENTRY_SAMPLING,
  sentryAngularTracingIntegration,
  markSentryErrorProbe,
  configureStructuredLogs,
  filterStructuredLog,
  filterStructuredLogEnvelope,
  filterSentryError,
  filterSentryBreadcrumb,
  filterSentryTransaction,
  filterSentrySpan,
  sentryReplayTransport,
  filterReplayCustomEvent,
  REPLAY_FINANCIAL_BLOCKS,
} from '@brighthub/logging';

// Shared across deployments; release promotion follows local verification.
const structuredLogConfig = { enabled: true, successSampleRate: 1 };
configureStructuredLogs(structuredLogConfig);

if (environment.production) {
  enableProdMode();
}

Sentry.init({
  dsn: environment.sentry['dsn'],
  environment: environment.sentry['environment'],
  release: environment.appVersion,
  enableLogs: structuredLogConfig.enabled,
  transport: sentryReplayTransport,
  beforeSendLog: filterStructuredLog,
  beforeSend: (event, hint) =>
    filterSentryError(markSentryErrorProbe(event, hint)),
  beforeBreadcrumb: filterSentryBreadcrumb,
  beforeSendTransaction: filterSentryTransaction,
  beforeSendSpan: filterSentrySpan,
  integrations: [
    sentryAngularTracingIntegration(),
    Sentry.replayIntegration({
      maskAllText: true,
      maskAllInputs: true,
      blockAllMedia: true,
      block: REPLAY_FINANCIAL_BLOCKS,
      networkDetailAllowUrls: [],
      networkDetailDenyUrls: [/.*/],
      networkCaptureBodies: false,
      networkRequestHeaders: [],
      networkResponseHeaders: [],
      attachRawBodyFromRequest: false,
      beforeAddRecordingEvent: filterReplayCustomEvent,
    }),
  ],

  ...SENTRY_SAMPLING,
});
Sentry.getClient()?.on('beforeEnvelope', filterStructuredLogEnvelope);
Sentry.setTag('app', 'brighthub');
bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    Sentry.addBreadcrumb({
      category: 'system',
      message: 'BrightHub bootstrapped',
      level: 'info',
    });
  })
  .catch((err) => {
    Sentry.captureException(err);
    console.error(err);
  });
